import axios from "../index";

const getAllCities = () => {
    return axios.get('all-cities');
}

export { getAllCities }